import React, { FC, PropsWithChildren, ReactElement, useState } from 'react';

import styles from './styles.module.css';

interface Props {
  className?: string;
  listClassName?: string;
  renderHeadComponent: (isActive: boolean) => ReactElement;
  horizontal?: boolean;
}

const AppDropdownMenu: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  renderHeadComponent,
  horizontal,
  listClassName,
}) => {
  const [visible, setVisible] = useState<boolean>(false);

  const handleMouseOver = () => {
    setVisible(true);
  };

  const handleMouseOut = () => {
    setVisible(false);
  };

  return (
    <div className={styles.dropdownContainer} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
      {renderHeadComponent(visible)}

      {children && visible && (
        <div className={`${horizontal ? styles.dropdownListHorizontal : styles.dropdownList} ${className}`}>
          <ul className={listClassName}>{children}</ul>
        </div>
      )}
    </div>
  );
};

export default AppDropdownMenu;
